import { useState, useEffect } from "react";
export function useResizeObserver(ref) {
  const [observedSize, setObservedSize] = useState({});
  useEffect(() => {
    if (ref?.current == null) return;
    const observer = new ResizeObserver(([entry]) => {
      setObservedSize({
        width: entry.borderBoxSize?.[0]?.inlineSize,
        height: entry.borderBoxSize?.[0]?.blockSize
      });
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return {
    observedSize
  };
}
//# sourceMappingURL=useResizeObserver.js.map